// Ensure all videos are muted (required for mobile autoplay)
document.querySelectorAll('.main-slider video').forEach(function(video) {
  video.muted = true;
  video.playsInline = true;
});

const thumbSwiper = new Swiper(".thumb-slider", {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});

const mainSwiper = new Swiper(".main-slider", {
  spaceBetween: 10,
  thumbs: {
    swiper: thumbSwiper,
  },
  on: {
    slideChangeTransitionEnd: function() {
      // Pause all videos
      document.querySelectorAll('.main-slider video').forEach(function(video) {
        video.pause();
        video.currentTime = 0;
      });
      // Play video in active slide
      var activeVideo = document.querySelector('.main-slider .swiper-slide-active video');
      if (activeVideo) {
        activeVideo.muted = true;
        activeVideo.play();
      }
    }
  }
});